export const All_DISTRIBUTOR = [
  { name: "Mouser", value: "Mouser", isActive: true },
  { name: "Digikey", value: "Digikey", isActive: true },
  { name: "Element14", value: "Element14", isActive: true },
  { name: "TME", value: "TME", isActive: true },
  { name: "Rutronik", value: "Rutronik", isActive: true },
  { name: "Arrow", value: "Arrow", isActive: true },
  { name: "TTI", value: "TTI", isActive: true },
  { name: "TI", value: "TI", isActive: true },
];

export const MOUSER_SALES_ORDER_IDS = {
  Mouser: [
    {
      name: "276781288",
      value: "276781288",
    },
  ],
};
